import { Howl } from 'howler';
import pop_notification from '../../assets/audio/pop_notification.mp3';

/**
 * Short "you need to interact" notification cue.
 *
 * Played when a spot is ready but waiting for a user tap:
 *  - audio spots with autoplay disabled (see experience `ready` handler)
 *  - video spots (which never autoplay)
 *
 * Playback path & iOS unlock:
 * Howler uses the WebAudio API by default (html5 is off, so _webAudio =
 * Howler.usingWebAudio, which is true on iOS Safari). WebAudio on iOS needs the
 * AudioContext to be unlocked by a user gesture once. Howler does this via
 * autoUnlock: creating a Howl registers document touch/click listeners that
 * resume the context on the NEXT gesture.
 *
 * IMPORTANT: geoXp bundles its own copy of howler, so its audio.unlock() does
 * NOT unlock this module's AudioContext. This Howl is therefore created eagerly
 * at import time (this module is imported by the experience context on app
 * load) so Howler's unlock listeners are registered BEFORE the user's first
 * tap. The Setup flow / Start tap then unlocks the context, well before any cue
 * fires. Creating it lazily would register the listeners too late and the first
 * cue would be silent on iOS.
 */
const cue = new Howl({
  src: [pop_notification],
  preload: true,
  volume: 0.6,
});

export const playCue = () => {
  try {
    cue.play();
  } catch (error) {
    console.warn('[cue] could not play notification cue', error);
  }
};
